@file:OptIn(InternalResourceApi::class)

package mifos_mobile.core.designsystem.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mifos_mobile.core.designsystem.generated.resources/"

public val Res.string.feature_upload_id_remove_file: StringResource by lazy {
      StringResource("string:feature_upload_id_remove_file", "feature_upload_id_remove_file", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 53),
      ))
    }

public val Res.string.feature_upload_id_select_new_file: StringResource by lazy {
      StringResource("string:feature_upload_id_select_new_file", "feature_upload_id_select_new_file", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64, 61),
      ))
    }

public val Res.string.feature_upload_id_view_file: StringResource by lazy {
      StringResource("string:feature_upload_id_view_file", "feature_upload_id_view_file", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 126, 47),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_upload_id_remove_file", Res.string.feature_upload_id_remove_file)
  map.put("feature_upload_id_select_new_file", Res.string.feature_upload_id_select_new_file)
  map.put("feature_upload_id_view_file", Res.string.feature_upload_id_view_file)
}
